import useMediaQuery from '@mui/material/useMediaQuery'
import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {addDialogToStack, addToPersonalStack} from 'entities/activity'
import {useConnectSocket} from 'entities/app'
import {socket} from 'entities/app/socket'
import {orderDialogList, GetDialogsRequest, addDialogList, DialogItemType, clearDialogsList} from 'entities/messages'

export const DialogsSocket = () => {
  const dispatch = useDispatch()
  const {pathname} = useLocation()
  const is768p = useMediaQuery('(max-width: 767px)')
  const connectSocket = useConnectSocket()

  useEffect(() => {
    if (pathname.includes('messages')) return

    GetDialogsRequest()
      .then(({data}) => dispatch(addDialogList(data)))
      .catch(console.error)
  }, [connectSocket])

  useEffect(() => {
    dispatch(clearDialogsList())
  }, [connectSocket])

  useEffect(() => {
    const chatMessageHandler = (dialog: DialogItemType) => {
      dispatch(orderDialogList(dialog))
      !is768p && dispatch(addDialogToStack(dialog))

      if (!is768p || dialog.interlocutor.id === dialog.lastMessage.to.id) return

      dispatch(addToPersonalStack({type: 'dialog', item: dialog}))
    }

    socket && socket.on('chat.message', chatMessageHandler)
    return () => {
      socket && socket.off('chat.message', chatMessageHandler)
    }
  }, [socket, is768p])

  return <></>
}